import {
    Box,
    VStack,
    HStack,
    Heading,
    Text,
    Button,
    Icon,
    Card,
    CardBody,
    Flex,
    Badge,
    Link,
    Divider
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { MdCheck, MdSettings } from 'react-icons/md';
import { FaRocket } from 'react-icons/fa';
import ContactSupport from '../components/ContactSupport';

const SubscriptionSuccess = () => {
    const navigate = useNavigate();

    return (
        <Box maxW="700px" mx="auto" p={6}>
            <VStack spacing={8} align="stretch">
                {/* Success Header */}
                <Box textAlign="center">
                    <Flex justify="center" mb={4}>
                        <Flex
                            w="80px"
                            h="80px"
                            bg="green.500"
                            color="white"
                            borderRadius="full"
                            align="center"
                            justify="center"
                            fontSize="2xl"
                        >
                            <Icon as={MdCheck as React.ElementType} />
                        </Flex>
                    </Flex>
                    <Heading size="xl" mb={2} color="green.600">
                        Subscription Succeeded!
                    </Heading>
                    <Text fontSize="lg" color="gray.600" mb={4}>
                        Your subscription has been successfully created and activated.
                    </Text>
                    <Badge colorScheme="green" px={3} py={1} borderRadius="full" fontSize="sm">
                        14-Day Free Trial Active
                    </Badge>
                </Box>

                {/* Setup Call Section */}
                <Card>
                    <CardBody>
                        <VStack spacing={6} align="stretch">
                            <Box textAlign="center">
                                <Heading size="md" mb={2} color="#0071E3">
                                    Let's Get You Set Up!
                                </Heading>
                                <Text color="gray.600" fontSize="sm">
                                    Schedule some time with our team to help you get the most out of Yaxle
                                </Text>
                            </Box>

                            <VStack spacing={4} align="stretch">
                                <HStack spacing={4} p={6} bg="blue.50" borderRadius="lg" align="center" justify="center">
                                    <Icon as={FaRocket as React.ElementType} color="#0071E3" fontSize="2xl" />
                                    <VStack align="center" spacing={2} flex={1}>
                                        <Text fontWeight="bold" fontSize="lg" textAlign="center">
                                            Schedule Your Setup Call
                                        </Text>
                                        <Text fontSize="sm" color="gray.600" textAlign="center">
                                            Our team will walk you through everything and answer any questions
                                        </Text>
                                        <Link
                                            href="https://cal.com/partbay/basicsetup"
                                            isExternal
                                            _hover={{ textDecoration: 'none' }}
                                        >
                                            <Button
                                                colorScheme="gray"
                                                bg="#0071E3"
                                                color="white"
                                                _hover={{ bg: "#364A9B" }}
                                                size="lg"
                                                mt={2}
                                            >
                                                Book Setup Call
                                            </Button>
                                        </Link>
                                    </VStack>
                                </HStack>
                            </VStack>
                        </VStack>
                    </CardBody>
                </Card>

                <Button
                    leftIcon={<Icon as={MdSettings as React.ElementType} />}
                    variant="outline"
                    colorScheme="gray"
                    size="md"
                    width="full"
                    onClick={() => navigate('/settings')}
                >
                    Manage Subscription
                </Button>

                <Divider />

                <ContactSupport />
            </VStack>
        </Box>
    );
};

export default SubscriptionSuccess; 